/**
 * WbSearchField — zoekveld 52 px met wis-knop.
 *
 * Mono-invoer (WI/WB-nummers) met `inputMode="numeric"` als standaard; zet
 * `inputMode="text"` voor namen. Het bronpatroon stond inline in
 * VoorinspectieListPage (fase 1).
 */

import { type InputHTMLAttributes, forwardRef } from 'react';
import clsx from 'clsx';

export interface WbSearchFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value'> {
  value: string;
  onChange: (value: string) => void;
  /** Mono-lettertype voor nummers (standaard aan). */
  mono?: boolean;
}

export const WbSearchField = forwardRef<HTMLInputElement, WbSearchFieldProps>(function WbSearchField(
  { value, onChange, mono = true, className, inputMode = 'numeric', placeholder = 'Zoek…', ...props },
  ref
) {
  return (
    <div className={clsx('relative', className)}>
      <input
        ref={ref}
        type="text"
        inputMode={inputMode}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={clsx(
          'wb-focus w-full min-h-tap pl-3 pr-12 bg-wb-vlak border-wb border-wb-rand rounded-wb text-base text-wb-inkt placeholder:text-wb-inkt3 placeholder:font-body',
          mono && 'font-mono'
        )}
        {...props}
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange('')}
          aria-label="Wis zoekopdracht"
          className="wb-focus absolute right-0 top-0 h-full w-12 flex items-center justify-center text-wb-inkt"
        >
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      )}
    </div>
  );
});
